// extracted by mini-css-extract-plugin
export default {"container":"Products_container__0kK+x","products":"Products_products__gjQIi","menu":"Products_menu__JL9YL","list":"Products_list__W3C6O","product":"Products_product__KVlHx"};